export default "__VITE_ASSET__u4X5AOLO__"